import Modal from "./Modal";
import React, { useEffect, useState } from "react";
import { ModalSize } from "../enums/ModalSize";
import Button from "../button/Button";
import { FormikValues, useFormikContext } from "formik";
import PasswordInput from "../input/PasswordInput";
import { buildIncompleteIntake } from "../../service/IncompleteIntakeService";
import { findEmailAddressFieldFor } from "../enums/Party";
import AlertBanner from "./AlertBanner";
import EmailInput from "../input/EmailInput";
import { useApolloClient, useMutation } from "@apollo/client";
import { CREATE_OR_UPDATE_INCOMPLETE_INTAKE_MUTATION } from "../../Queries";

export type SaveIncompleteIntakeModalProps = {
    onModalClose?: (e: Event) => void,
    children?: React.ReactNode
}

const SaveIncompleteIntakeModal = (props: SaveIncompleteIntakeModalProps) => {
    const [alert, setAlert] = useState(<></>)
    const formikContext = useFormikContext<FormikValues>();
    const [createOrUpdateIncompleteIntake] = useMutation(CREATE_OR_UPDATE_INCOMPLETE_INTAKE_MUTATION)
    const apolloClient = useApolloClient()

    const setFieldValue = formikContext.setFieldValue;
    const values = formikContext.values;
    const incompleteIntakeEmailAddress = values.incompleteIntakeEmailAddress;
    const emailAddressField = findEmailAddressFieldFor(values.party)
    const prefillEmailAddress = emailAddressField ? values[emailAddressField] : undefined

    useEffect(() => {
        if(incompleteIntakeEmailAddress) {
            return;
        }
        setFieldValue('incompleteIntakeEmailAddress', prefillEmailAddress)
    }, [setFieldValue, incompleteIntakeEmailAddress, prefillEmailAddress])

    return <Modal id="save-incomplete-intake"
                  headerText="Save claim form progress"
                  onClose={props.onModalClose}
                  modalContent={
                      <div className="flex-gap">
                          <div>We don't want you to lose all of your hard work, so we'll save your spot! Come back and pick up right where you left off when you're ready to finish and submit your claim.</div>
                          <div className="flex-gap">
                              <ul className="pds-u-margin-vertical-0">
                                  <li>Saving form progress is <b>not</b> the same as submitting your claim to Principal for processing.</li>
                                  <li>To submit your claim, close this screen and proceed through the remaining steps of the form until you click the "Submit claim" button.</li>
                                  <li>Uploaded documents will not be saved.</li>
                                  <li>The data you've entered is encrypted and a unique access link is sent to your email.</li>
                                  <li>The data at this link is accessible only by the passkey you set at the time of saving.</li>
                              </ul>
                              <small>Reminder: Store passkeys in a secure, private location. Principal is unable to retrieve a lost or stolen passkey.</small>
                          </div>
                          <div>
                              <EmailInput id="incomplete-intake-email-address" required={true} label="Email address"/>
                              <PasswordInput id="incomplete-intake-password" label="Passkey"/>
                          </div>
                          {alert}
                      </div>}
                  modalFooter={
                      <>
                          {'success' !== alert.props.variant
                              && <Button type="button" buttonContent="Save and send link" onClick={async () => {
                                  try {
                                      setAlert(<></>)
                                      const incompleteIntakeInput = await buildIncompleteIntake(values, apolloClient.cache)
                                      await createOrUpdateIncompleteIntake({
                                          variables: {
                                              incompleteIntakeInput
                                          }
                                      })
                                      setAlert(<AlertBanner variant="success"
                                                            message={
                                                                <div>
                                                                    <div>Successfully sent your continue link
                                                                        to {values.incompleteIntakeEmailAddress}.
                                                                    </div>
                                                                    <div><strong>This link will remain valid for 30 days.</strong></div>
                                                                </div>
                                                            }
                                                            hideDismissButton={true}/>)
                                  } catch (e) {
                                      console.log(e)
                                      setAlert(<AlertBanner variant="error"
                                                            message={<div>Could not send email. Please verify your email address and passkey
                                                                and try again.</div>}
                                                            hideDismissButton={true}/>)
                                  }
                              }}/>}
                      </>}
                  modalSize={ModalSize.LARGE}
                  closeable={true}/>;
}

export default SaveIncompleteIntakeModal;
